// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__v2qAT","badges":"styles_badges__2v6zO"};